import clsx from 'clsx'

import type { Methods as AnnouncementMethods } from '@/api/v1/announcements'

export type AnnouncementTag =
  AnnouncementMethods['get']['resBody']['announcements'][number]['tag']

export type AnnouncementTagTabValue = Exclude<
  NonNullable<AnnouncementMethods['get']['query']>['tag'],
  undefined
>

export type AnnouncementTagLabelKey =
  | 'announcement.tags.all'
  | 'announcement.tags.important'
  | 'announcement.tags.newFeature'
  | 'announcement.tags.productInfo'
  | 'announcement.tags.other'

export type AnnouncementTagMeta = {
  labelKey: AnnouncementTagLabelKey
  badgeVariant: 'danger' | 'primary' | 'success' | 'default'
}

export const ANNOUNCEMENT_TAG_MAP: Record<
  AnnouncementTag,
  AnnouncementTagMeta
> = {
  important: {
    labelKey: 'announcement.tags.important',
    badgeVariant: 'danger',
  },
  newFeature: {
    labelKey: 'announcement.tags.newFeature',
    badgeVariant: 'primary',
  },
  productInfo: {
    labelKey: 'announcement.tags.productInfo',
    badgeVariant: 'success',
  },
  other: {
    labelKey: 'announcement.tags.other',
    badgeVariant: 'default',
  },
}

export const ANNOUNCEMENT_TAG_TABS: {
  value: AnnouncementTagTabValue
  labelKey: AnnouncementTagLabelKey
}[] = [
  { value: 'important', labelKey: 'announcement.tags.important' },
  { value: 'newFeature', labelKey: 'announcement.tags.newFeature' },
  { value: 'productInfo', labelKey: 'announcement.tags.productInfo' },
  { value: 'other', labelKey: 'announcement.tags.other' },
  { value: 'all', labelKey: 'announcement.tags.all' },
]

export const ANNOUNCEMENT_BADGE_CLASSES: Record<
  AnnouncementTagMeta['badgeVariant'],
  string
> = {
  danger: clsx('tw-bg-labelRed-50 tw-text-labelRed-500'),
  primary: clsx('tw-bg-labelBlue-50 tw-text-labelBlue-500'),
  success: clsx('tw-bg-success-50 tw-text-green-600'),
  default: clsx('tw-bg-labelGray-50 tw-text-labelGray-500'),
}
